//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as jQuery from 'jquery';

export class CommandClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Execute the set command for control.
     * @param gridId Grid ID.
     * @param controlId Control ID.
     * @param body (optional) Parameters for command execution.
     * @return OK
     */
    set(gridId: number, controlId: number, body: CommandDataRowContextParameter | undefined, onSuccess?: (result: ExecuteResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/command/set/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSet(xhr: any): ExecuteResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExecuteResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Execute the command for multipageupdate.
     * @param gridId Grid ID.
     * @param controlId Control ID.
     * @param body (optional) Parameters for command execution.
     * @return OK
     */
    setMultiple(gridId: number, controlId: number, body: CommandMultipleDataRowContextParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/command/setmultiple/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetMultipleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetMultipleWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetMultipleWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetMultiple(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetMultiple(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Execute the command for dataset.
     * @param gridId Grid ID.
     * @param controlId Control ID.
     * @param body (optional) Parameters for command execution.
     * @return OK
     */
    setDataset(gridId: number, controlId: number, body: CommandRequestParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/command/setdataset/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetDatasetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetDatasetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetDatasetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetDataset(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetDataset(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Execute the command for column selector command.
     * @param gridId Grid ID.
     * @param controlId Control ID.
     * @param body (optional) Parameters for command execution.
     * @return OK
     */
    setColumnSelector(gridId: number, controlId: number, body: CommandMultipleDataRowContextParameter | undefined, onSuccess?: (result: ColumnSelectorExecuteResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/command/setcolumnselector/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetColumnSelectorWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetColumnSelectorWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetColumnSelectorWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetColumnSelector(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetColumnSelector(xhr: any): ColumnSelectorExecuteResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ColumnSelectorExecuteResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Execute the get command for control.
     * @param gridId Grid ID.
     * @param controlId Control ID.
     * @param body (optional) Parameters for command execution.
     * @return OK
     */
    get(gridId: number, controlId: number, body: CommandDataRowContextParameter | undefined, onSuccess?: (result: CommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/command/get/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): CommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Get the values for checkbox filtering of a column.
     * @param gridId Id of the grid.
     * @param controlId Id of the control.
     * @param body (optional) Request parameters.
     * @return OK
     */
    getFilter(gridId: number, controlId: number, body: CommandRequestParameter | undefined, onSuccess?: (result: CommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/command/getfilter/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetFilterWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetFilterWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetFilterWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetFilter(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetFilter(xhr: any): CommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    treeLinkCommand(gridId: number, treeLinkId: number, body: CommandContextTreeParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/command/treelinkcommand/{gridId}/{treeLinkId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (treeLinkId === undefined || treeLinkId === null)
            throw new Error("The parameter 'treeLinkId' must be defined.");
        url_ = url_.replace("{treeLinkId}", encodeURIComponent("" + treeLinkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processTreeLinkCommandWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processTreeLinkCommandWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processTreeLinkCommandWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processTreeLinkCommand(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processTreeLinkCommand(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class DatasheetClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    get(body: DatasheetDefinitionContextParameter | undefined, onSuccess?: (result: DatasheetDefinition) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/datasheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): DatasheetDefinition | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatasheetDefinition;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCellValue(body: SetMultipleCellValueParameter | undefined, onSuccess?: (result: SetCellValueResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/datasheet/setcellvalue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetCellValueWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetCellValueWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetCellValueWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetCellValue(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetCellValue(xhr: any): SetCellValueResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetCellValueResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    executeCommand(body: ExecuteCommandParameter | undefined, onSuccess?: (result: DatasheetCommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/datasheet/executecommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processExecuteCommandWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processExecuteCommandWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processExecuteCommandWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processExecuteCommand(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processExecuteCommand(xhr: any): DatasheetCommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatasheetCommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class DropDownClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get combobox data for single control.
     * @param gridId ID of the Grid.
     * @param controlId Control ID.
     * @param body (optional) Request parameters.
     * @return OK
     */
    getControl(gridId: number, controlId: number, body: DropDownRequestParameter | undefined, onSuccess?: (result: DropDownCommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/dropdown/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetControlWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetControlWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetControlWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetControl(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetControl(xhr: any): DropDownCommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropDownCommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Get combobox data for whole grid.
     * @param gridId ID of the Grid.
     * @param body (optional) Request parameters.
     * @return OK
     */
    get(gridId: number, body: MultipleControlRequestParameter | undefined, onSuccess?: (result: { [key: string]: DropDownCommandResult; }) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/dropdown/{gridId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): { [key: string]: DropDownCommandResult; } | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: DropDownCommandResult; };
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Gets the index of a single data item in combobox data.
     * @param gridId ID of the Grid.
     * @param controlId Control ID.
     * @param body (optional) Request parameters which contain the selected value.
     * @return OK
     */
    mapValue(gridId: number, controlId: number, body: DropDownRequestParameter | undefined, onSuccess?: (result: DropDownCommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/dropdown/{gridId}/{controlId}/mapvalue";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processMapValueWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processMapValueWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processMapValueWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processMapValue(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processMapValue(xhr: any): DropDownCommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropDownCommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class EnvironmentClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(onSuccess?: (result: Environment) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/environment";
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): Environment | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Environment;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class ExportClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Export grids to excel.
     * @param body (optional) Parameter which contains infos like gridIds, etc.
     * @return OK
     */
    export(languageCode: string, body: ExportContextParameter | undefined, onSuccess?: (result: ExportResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/export/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processExportWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processExportWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processExportWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processExport(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processExport(xhr: any): ExportResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class FileDownloadClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param fileId (optional) 
     * @param objectId (optional) 
     * @param tableName (optional) 
     * @return OK
     */
    get(fileId: number | undefined, objectId: number | undefined, tableName: string | undefined, onSuccess?: (result: DownloadFile) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/filedownload?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (objectId === null)
            throw new Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        if (tableName === null)
            throw new Error("The parameter 'tableName' cannot be null.");
        else if (tableName !== undefined)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): DownloadFile | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadFile;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class FileUploadClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param files (optional) 
     * @param controlID (optional) ID of the FileUploadControl.
     * @param pageToken (optional) Gets or sets pageToken
     * @return OK
     */
    upload(files: FileParameter[] | undefined, controlID: number | undefined, pageToken: string | undefined, onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/fileupload/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (controlID === null || controlID === undefined)
            throw new Error("The parameter 'controlID' cannot be null.");
        else
            content_.append("ControlID", controlID.toString());
        if (pageToken === null || pageToken === undefined)
            throw new Error("The parameter 'pageToken' cannot be null.");
        else
            content_.append("PageToken", pageToken.toString());

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            contentType: false,
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processUploadWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUploadWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processUploadWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpload(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpload(xhr: any): string | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param fileNames (optional) 
     * @param controlID (optional) ID of the FileUploadControl.
     * @param pageToken (optional) Gets or sets pageToken
     * @return OK
     */
    remove(fileNames: string[] | undefined, controlID: number | undefined, pageToken: string | undefined, onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/fileupload/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileNames === null || fileNames === undefined)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else
            fileNames.forEach(item_ => content_.append("fileNames", item_.toString()));
        if (controlID === null || controlID === undefined)
            throw new Error("The parameter 'controlID' cannot be null.");
        else
            content_.append("ControlID", controlID.toString());
        if (pageToken === null || pageToken === undefined)
            throw new Error("The parameter 'pageToken' cannot be null.");
        else
            content_.append("PageToken", pageToken.toString());

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            contentType: false,
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processRemoveWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRemoveWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processRemoveWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRemove(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRemove(xhr: any): string | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class GlobalSearchClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    post(body: GlobalSearchParameter | undefined, onSuccess?: (result: GlobalSearchResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/globalsearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processPostWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPostWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processPostWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPost(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPost(xhr: any): GlobalSearchResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GlobalSearchResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class GridCommandClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Executes multiple GridCommands at once.
     * @param gridId GridID
     * @param body (optional) GridCommands which should be executed.
     * @return OK
     */
    post(gridId: number, body: GridCommandRequestParameter | undefined, onSuccess?: (result: { [key: string]: CommandResult; }) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/gridcommand/{gridId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processPostWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPostWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processPostWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPost(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPost(xhr: any): { [key: string]: CommandResult; } | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: CommandResult; };
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class GridDataClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get data for grids.
     * @param gridId GridID
     * @param body (optional) Request parameters (i.e. Take, Skip,...)
     * @return OK
     */
    get(gridId: number, body: CommandRequestParameter | undefined, onSuccess?: (result: CommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/griddata/{gridId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): CommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class GridDataTreeClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get data for grids.
     * @param gridId GridID
     * @param body (optional) Request parameters (i.e. Take, Skip,...)
     * @return OK
     */
    get(gridId: number, body: CommandContextTreeParameter | undefined, onSuccess?: (result: CommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/griddatatree/{gridId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): CommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class GridDefinitionClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get all grid definitions for a mapping.
     * @param mappingName Name of mapping.
     * @param mappingDisplayType (optional) Display type for mapping.
    0 = FilterAndGrids
    1 = GridsOnly
    2 = FiltersOnly
     * @param body (optional) Context parameters.
     * @return OK
     */
    getAll(mappingName: string, mappingDisplayType: MappingDisplayTypes | undefined, body: ContextParameter | undefined, onSuccess?: (result: MappingDefinition) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/griddefinition/{mappingName}?";
        if (mappingName === undefined || mappingName === null)
            throw new Error("The parameter 'mappingName' must be defined.");
        url_ = url_.replace("{mappingName}", encodeURIComponent("" + mappingName));
        if (mappingDisplayType === null)
            throw new Error("The parameter 'mappingDisplayType' cannot be null.");
        else if (mappingDisplayType !== undefined)
            url_ += "mappingDisplayType=" + encodeURIComponent("" + mappingDisplayType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetAllWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): MappingDefinition | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MappingDefinition;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Get a single griddefinition.
     * @param mappingName Name of the mapping.
     * @param gridID Id of the grid.
     * @param body (optional) Context parameter.
     * @return OK
     */
    getSingle(mappingName: string, gridID: number, body: CommandContextParameter | undefined, onSuccess?: (result: BaseGridDefinition) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/griddefinition/{mappingName}/{gridID}";
        if (mappingName === undefined || mappingName === null)
            throw new Error("The parameter 'mappingName' must be defined.");
        url_ = url_.replace("{mappingName}", encodeURIComponent("" + mappingName));
        if (gridID === undefined || gridID === null)
            throw new Error("The parameter 'gridID' must be defined.");
        url_ = url_.replace("{gridID}", encodeURIComponent("" + gridID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetSingleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetSingleWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetSingleWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetSingle(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetSingle(xhr: any): BaseGridDefinition | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseGridDefinition;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class IfcExportClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getExportType(exportTypeId: number, body: PageTokenParameter | undefined, onSuccess?: (result: ExportType) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/ifcexport/exporttype/{exportTypeId}";
        if (exportTypeId === undefined || exportTypeId === null)
            throw new Error("The parameter 'exportTypeId' must be defined.");
        url_ = url_.replace("{exportTypeId}", encodeURIComponent("" + exportTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetExportTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetExportTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetExportTypeWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetExportType(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetExportType(xhr: any): ExportType | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportType;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    export(exportTypeId: number, body: IfcExportRequest | undefined, onSuccess?: (result: IfcExportResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/ifcexport/{exportTypeId}";
        if (exportTypeId === undefined || exportTypeId === null)
            throw new Error("The parameter 'exportTypeId' must be defined.");
        url_ = url_.replace("{exportTypeId}", encodeURIComponent("" + exportTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processExportWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processExportWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processExportWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processExport(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processExport(xhr: any): IfcExportResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IfcExportResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFile(body: DownloadFileRequest | undefined, onSuccess?: (result: DownloadFile) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/ifcexport/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetFileWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetFileWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetFileWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetFile(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetFile(xhr: any): DownloadFile | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadFile;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class IfcImportClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getImportType(importTypeId: number, body: PageTokenParameter | undefined, onSuccess?: (result: ImportType) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/ifcimport/importtype/{importTypeId}";
        if (importTypeId === undefined || importTypeId === null)
            throw new Error("The parameter 'importTypeId' must be defined.");
        url_ = url_.replace("{importTypeId}", encodeURIComponent("" + importTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetImportTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetImportTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetImportTypeWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetImportType(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetImportType(xhr: any): ImportType | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportType;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    import(importTypeId: number, body: ImportRequest | undefined, onSuccess?: (result: ImportResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/ifcimport/{importTypeId}";
        if (importTypeId === undefined || importTypeId === null)
            throw new Error("The parameter 'importTypeId' must be defined.");
        url_ = url_.replace("{importTypeId}", encodeURIComponent("" + importTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processImportWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processImportWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processImportWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processImport(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processImport(xhr: any): ImportResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param files (optional) 
     * @param queryParameters (optional) Gets or sets parameters from the query string.
     * @param applicationParameters (optional) Gets or sets application parameters.
     * @param pageToken (optional) Gets or sets pageToken
     * @return OK
     */
    uploadFile(files: FileParameter[] | undefined, queryParameters: { [key: string]: any; } | undefined, applicationParameters: { [key: string]: any; } | undefined, pageToken: string | undefined, onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/ifcimport/uploadfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (queryParameters === null || queryParameters === undefined)
            throw new Error("The parameter 'queryParameters' cannot be null.");
        else
            content_.append("QueryParameters", JSON.stringify(queryParameters));
        if (applicationParameters === null || applicationParameters === undefined)
            throw new Error("The parameter 'applicationParameters' cannot be null.");
        else
            content_.append("ApplicationParameters", JSON.stringify(applicationParameters));
        if (pageToken === null || pageToken === undefined)
            throw new Error("The parameter 'pageToken' cannot be null.");
        else
            content_.append("PageToken", pageToken.toString());

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            contentType: false,
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processUploadFileWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUploadFileWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processUploadFileWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUploadFile(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUploadFile(xhr: any): string | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param fileNames (optional) 
     * @param queryParameters (optional) Gets or sets parameters from the query string.
     * @param applicationParameters (optional) Gets or sets application parameters.
     * @param pageToken (optional) Gets or sets pageToken
     * @return OK
     */
    removeFile(fileNames: string[] | undefined, queryParameters: { [key: string]: any; } | undefined, applicationParameters: { [key: string]: any; } | undefined, pageToken: string | undefined, onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/ifcimport/removefile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileNames === null || fileNames === undefined)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else
            fileNames.forEach(item_ => content_.append("fileNames", item_.toString()));
        if (queryParameters === null || queryParameters === undefined)
            throw new Error("The parameter 'queryParameters' cannot be null.");
        else
            content_.append("QueryParameters", JSON.stringify(queryParameters));
        if (applicationParameters === null || applicationParameters === undefined)
            throw new Error("The parameter 'applicationParameters' cannot be null.");
        else
            content_.append("ApplicationParameters", JSON.stringify(applicationParameters));
        if (pageToken === null || pageToken === undefined)
            throw new Error("The parameter 'pageToken' cannot be null.");
        else
            content_.append("PageToken", pageToken.toString());

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            contentType: false,
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processRemoveFileWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRemoveFileWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processRemoveFileWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRemoveFile(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRemoveFile(xhr: any): string | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class ImageClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get database image for single control.
     * @param gridId ID of the Grid.
     * @param controlId Control ID.
     * @param body (optional) Request parameters.
     * @return OK
     */
    getControl(gridId: number, controlId: number, body: CommandDataRowContextParameter | undefined, onSuccess?: (result: DatabaseImageResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/image/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetControlWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetControlWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetControlWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetControl(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetControl(xhr: any): DatabaseImageResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatabaseImageResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Get database images for whole grid.
     * @param gridId ID of the Grid.
     * @param body (optional) Request parameters.
     * @return OK
     */
    get(gridId: number, body: MultipleControlRequestParameter | undefined, onSuccess?: (result: { [key: string]: DatabaseImageResult; }) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/image/{gridId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): { [key: string]: DatabaseImageResult; } | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: DatabaseImageResult; };
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class LanguageClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(onSuccess?: (result: Language[]) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/language";
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): Language[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Language[];
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class MenuClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(onSuccess?: (result: Menu) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/menu";
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): Menu | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Menu;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class MultipleDatasheetClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    get(body: DatasheetDefinitionContextParameter | undefined, onSuccess?: (result: DatasheetDefinition[]) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/multipledatasheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): DatasheetDefinition[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatasheetDefinition[];
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCellValue(body: SetMultipleCellValueParameter | undefined, onSuccess?: (result: SetCellValueResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/multipledatasheet/setcellvalue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetCellValueWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetCellValueWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetCellValueWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetCellValue(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetCellValue(xhr: any): SetCellValueResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetCellValueResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    executeCommand(body: ExecuteCommandParameter | undefined, onSuccess?: (result: DatasheetCommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/multipledatasheet/executecommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processExecuteCommandWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processExecuteCommandWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processExecuteCommandWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processExecuteCommand(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processExecuteCommand(xhr: any): DatasheetCommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatasheetCommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class NotificationClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendCurrentUser(body: PageTokenParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSendCurrentUserWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSendCurrentUserWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSendCurrentUserWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSendCurrentUser(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSendCurrentUser(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendAll(body: PageTokenParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/notification/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSendAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSendAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSendAllWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSendAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSendAll(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class PageTokenClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(onSuccess?: (result: PageTokenResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/pagetoken";
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): PageTokenResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PageTokenResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * "Touches" the pageToken -> update the timestamp.
     * @param body (optional) Param which holds the pageToken.
     * @return OK
     */
    touch(body: PageTokenParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/pagetoken/touch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processTouchWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processTouchWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processTouchWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processTouch(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processTouch(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Releases all page resources for a pageToken.
     * @param body (optional) Param which holds the pageToken
     * @return OK
     */
    release(body: PageTokenParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/pagetoken/release";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processReleaseWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processReleaseWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processReleaseWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRelease(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRelease(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class PeoplePickerClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get combobox data for single control.
     * @param gridId ID of the Grid.
     * @param controlId Control ID.
     * @param body (optional) Request parameters.
     * @return OK
     */
    getControl(gridId: number, controlId: number, body: DropDownRequestParameter | undefined, onSuccess?: (result: CommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/peoplepicker/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetControlWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetControlWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetControlWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetControl(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetControl(xhr: any): CommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Get combobox data for whole grid.
     * @param gridId ID of the Grid.
     * @param body (optional) Request parameters.
     * @return OK
     */
    get(gridId: number, body: MultipleControlRequestParameter | undefined, onSuccess?: (result: { [key: string]: CommandResult; }) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/peoplepicker/{gridId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): { [key: string]: CommandResult; } | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: CommandResult; };
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class PlanningsheetClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    get(body: PlanningsheetDefinitionContextParameter | undefined, onSuccess?: (result: PlanningsheetDefinition) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/planningsheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): PlanningsheetDefinition | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlanningsheetDefinition;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCellValue(body: SetCellValueParameter | undefined, onSuccess?: (result: PlanningsheetSetCellValueResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/planningsheet/setcellvalue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetCellValueWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetCellValueWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetCellValueWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetCellValue(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetCellValue(xhr: any): PlanningsheetSetCellValueResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlanningsheetSetCellValueResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    executeCommand(body: ExecuteCommandParameter | undefined, onSuccess?: (result: DatasheetCommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/planningsheet/executecommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processExecuteCommandWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processExecuteCommandWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processExecuteCommandWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processExecuteCommand(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processExecuteCommand(xhr: any): DatasheetCommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatasheetCommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class RefreshCacheClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(onSuccess?: (result: RefreshCacheProvider[]) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/refreshcache";
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): RefreshCacheProvider[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RefreshCacheProvider[];
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refresh(body: string[] | undefined, onSuccess?: (result: string[]) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/refreshcache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processRefreshWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRefreshWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processRefreshWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRefresh(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRefresh(xhr: any): string[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class ReportsClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param reportName (optional) 
     * @return OK
     */
    getParameters(reportName: string | undefined, onSuccess?: (result: ReportParameter[]) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/reports/parameters?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetParametersWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetParametersWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetParametersWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetParameters(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetParameters(xhr: any): ReportParameter[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportParameter[];
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param reportName (optional) 
     * @param body (optional) 
     * @return OK
     */
    getContent(reportName: string | undefined, body: ReportExecution | undefined, onSuccess?: (result: ReportContent) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/reports?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetContentWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetContentWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetContentWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetContent(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetContent(xhr: any): ReportContent | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportContent;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param reportName (optional) 
     * @param format (optional) 
     * @param body (optional) 
     * @return OK
     */
    export(reportName: string | undefined, format: string | undefined, body: ReportExecution | undefined, onSuccess?: (result: ReportExport) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/reports/export?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processExportWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processExportWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processExportWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processExport(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processExport(xhr: any): ReportExport | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportExport;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class TextBlockClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get textblocks for given languageCode and comma separated categories.
     * @param languageCode The code of the language, i.e. 'D', 'E'.
     * @param categories The textblock categories comma separated, i.e. 'main,global'.
     * @return OK
     */
    get(languageCode: string, categories: string, onSuccess?: (result: { [key: string]: { [key: string]: string; }; }) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/textblock/{languageCode}/{categories}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        if (categories === undefined || categories === null)
            throw new Error("The parameter 'categories' must be defined.");
        url_ = url_.replace("{categories}", encodeURIComponent("" + categories));
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): { [key: string]: { [key: string]: string; }; } | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: { [key: string]: string; }; };
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Sets textblocks.
     * @param languageCode Language.
     * @param autogeneratetb (optional) True if textBlockModules should be generated
     * @param body (optional) Dictionary of Dictionary with "TextBlockCategory" : { "TextBlockName" : "", "TextBlockName2" : ""}, "TextBlockCategory2": {...}
     * @return OK
     */
    set(languageCode: string, autogeneratetb: boolean | undefined, body: { [key: string]: { [key: string]: string; }; } | undefined, onSuccess?: () => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/textblock/{languageCode}?";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        if (autogeneratetb === null)
            throw new Error("The parameter 'autogeneratetb' cannot be null.");
        else if (autogeneratetb !== undefined)
            url_ += "autogeneratetb=" + encodeURIComponent("" + autogeneratetb) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSet(xhr: any): void {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            return;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return;
    }
}

export class UserClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getUser(id: number, body: PageTokenParameter | undefined, onSuccess?: (result: UserPickerItem) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetUserWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetUserWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetUserWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetUser(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetUser(xhr: any): UserPickerItem | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPickerItem;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setStartPage(body: StartPageRequestParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/user/setstartpage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetStartPageWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetStartPageWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetStartPageWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetStartPage(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetStartPage(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Get userpicker data for single control.
     * @param gridId ID of the Grid.
     * @param controlId Control ID.
     * @param body (optional) Request parameters.
     * @return OK
     */
    getControl(gridId: number, controlId: number, body: DropDownRequestParameter | undefined, onSuccess?: (result: CommandResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/user/picker/{gridId}/{controlId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetControlWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetControlWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetControlWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetControl(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetControl(xhr: any): CommandResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommandResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Get userpicker data for whole grid.
     * @param gridId ID of the Grid.
     * @param body (optional) Request parameters.
     * @return OK
     */
    get(gridId: number, body: MultipleControlRequestParameter | undefined, onSuccess?: (result: { [key: string]: CommandResult; }) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/user/picker/{gridId}";
        if (gridId === undefined || gridId === null)
            throw new Error("The parameter 'gridId' must be defined.");
        url_ = url_.replace("{gridId}", encodeURIComponent("" + gridId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): { [key: string]: CommandResult; } | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: CommandResult; };
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class UserGridConfigClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Sets UserGridConfiguration
     * @param body (optional) Context parameter.
     * @return OK
     */
    setUserMappingConfig(body: UserMappingConfigContextParameter | undefined, onSuccess?: (result: UserMappingConfigResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/usergridconfig/set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetUserMappingConfigWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetUserMappingConfigWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetUserMappingConfigWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetUserMappingConfig(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetUserMappingConfig(xhr: any): UserMappingConfigResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserMappingConfigResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Sets UserGridConfiguration
     * @param body (optional) Context parameter.
     * @return OK
     */
    setInitialUserMappingConfig(body: UserMappingConfigContextParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/usergridconfig/setinitial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processSetInitialUserMappingConfigWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetInitialUserMappingConfigWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processSetInitialUserMappingConfigWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetInitialUserMappingConfig(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetInitialUserMappingConfig(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    /**
     * Sets UserGridConfiguration
     * @param body (optional) Context parameter.
     * @return OK
     */
    deleteUserMappingConfig(body: UserMappingConfigContextParameter | undefined, onSuccess?: (result: BaseResult) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/usergridconfig/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processDeleteUserMappingConfigWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteUserMappingConfigWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processDeleteUserMappingConfigWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDeleteUserMappingConfig(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDeleteUserMappingConfig(xhr: any): BaseResult | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResult;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class VersionClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(onSuccess?: (result: VersionInfo) => void, onFail?: (exception: string, reason: string) => void): JQueryXHR {
        let url_ = this.baseUrl + "/dmsapi/version";
        url_ = url_.replace(/[?&]$/, "");

        let jqXhr = jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        });

        jqXhr.done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });

        return jqXhr;
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): VersionInfo | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

/** Definition of an add link which is on top of a mapping. */
export interface AddLinkDefinition {
    /** Gets or sets add Link Url */
    Url?: string | undefined;
    /** Gets or sets add Link Mode */
    UrlMode?: string | undefined;
    /** Gets or sets add Link TextBlock */
    TextBlock?: string | undefined;
}

/** Entry for aggregations. */
export interface AggregateItem {
    /** Gets or sets field to be aggregated. */
    Field?: string | undefined;
    /** Gets or sets aggregate function. */
    Aggregate?: string | undefined;
    /** Gets or sets name of the column which contains the aggregate. */
    ColumnName?: string | undefined;
}

/** Common column definition for several grids. */
export interface BaseColumnDefinition {
    /** Gets or sets alignment of the column. */
    AlignmentID?: number;
    /** Gets or sets cssClass. */
    CssClass?: string | undefined;
    /** Gets or sets tooltip of the column. */
    Tooltip?: string | undefined;
    /** Gets list of controls in this column. */
    readonly Controls: ControlDefinition[];
    /** Gets or sets help text for the column. */
    HelpTextBlockName?: string | undefined;
    /** Gets or sets name of column. */
    ColumnName?: string | undefined;
    /** Gets or sets column header TextBlock. */
    ColumnHeader: string;
}

/** Common GridDefinition for all grid types. */
export interface BaseGridDefinition {
    BaseColumns?: BaseColumnDefinition[] | undefined;
    /** Gets or sets id of the form. */
    GridID: number;
    /** Gets or sets name of the form. */
    GridName: string;
    /** Gets or sets fixed width for the form. */
    GridWidth?: string | undefined;
    /** Gets or sets gridtype. */
    GridTypeID: number;
    GridType?: GridTypes;
    /** Gets or sets dictionary for GridCommands. The key is the GridCommandID. */
    GridCommands?: { [key: string]: GridCommandDefinition; } | undefined;
    /** Gets or sets a value indicating whether true if editing is enabled and allowed. */
    EditAllowed?: boolean;
    /** Gets or sets a value indicating whether true if adding is enabled and allowed. */
    AddAllowed?: boolean;
    /** Gets or sets get Height of Grid */
    GridHeight?: string | undefined;
    /** Gets or sets get ClientGridScriptDefinition */
    GridScriptDefinition?: GridScriptDefinition[] | undefined;
    /** Gets or sets values which are fixed and can't be changed. These are mostly default values of controls which are not visible for the user. */
    FixedValues?: FixedValueDefinition[] | undefined;
    /** Gets or sets a value indicating whether gets or sets if the user is allowed to save custom user grid configurations. */
    CanUserGridConfig?: boolean;
    /** Gets or sets the custom user grid configuration. */
    UserGridConfig?: UserGridConfigDefinition[] | undefined;
    /** Gets or sets a value indicating whether true if the grid should be shown on default. */
    ShowDefault?: boolean;
    /** Gets or sets a value indicating whether gets or sets if the user is allowed to save system wide user grid configurations. */
    AllowSystemGridConfig?: boolean;
    /** Gets or sets a value indicating whether the user should be notified for unsaved changes. */
    EnableChangeTracking?: boolean;
}

export interface BaseResult {
    /** Gets or sets error / Exception info. */
    Error?: string | undefined;
    /** Gets or sets detailed exception info including stack traces. */
    ErrorDetail?: string | undefined;
    /** Gets or sets detailed exception info including stack traces. */
    ErrorID?: number | undefined;
    /** Gets or sets detailed exception info including stack traces. */
    ErrorTextBlockName?: string | undefined;
    /** Gets or sets true if the session is expired or the pageToken is invalid. */
    IsSessionExpired?: boolean | undefined;
    /** Gets or sets the textblock category for the error. */
    ErrorTextBlockCategory?: string | undefined;
}

export interface CellStyle {
    BackgroundColor?: string | undefined;
    ForegroundColor?: string | undefined;
    EditorBackgroundColor?: string | undefined;
    EditorForegroundColor?: string | undefined;
    IsBold?: boolean;
    IsItalic?: boolean;
    HorizontalAlignment?: HorizontalAlignment;
    TextVerticalAlign?: string | undefined;
    CssClass?: string | undefined;
    CssStyle?: string | undefined;
}

/** 1 = Text 2 = Number 3 = Date 4 = DateTime 5 = Formula 9 = SelectList 10 = TextBlock 11 = Icon 12 = Collapse 13 = TextArea 14 = Link */
export enum CellTypes {
    Text = 1,
    Number = 2,
    Date = 3,
    DateTime = 4,
    Formula = 5,
    SelectList = 9,
    TextBlock = 10,
    Icon = 11,
    Collapse = 12,
    TextArea = 13,
    Link = 14,
}

/** The result of a command execution. */
export interface ExecuteResult extends BaseResult {
    /** Gets or sets output parameters delievered by the command. */
    outputParameters?: { [key: string]: any; } | undefined;
}

/** The result of a command execution. */
export interface ColumnSelectorExecuteResult extends ExecuteResult {
    HasExecutionError?: boolean;
}

/** 1 = Standard 2 = Button 3 = Submitbutton 4 = Group 5 = ColumnSelector */
export enum ColumnTypes {
    Standard = 1,
    Button = 2,
    Submitbutton = 3,
    Group = 4,
    ColumnSelector = 5,
}

export interface Command {
    CommandID?: string | undefined;
    Cells?: CommandCell[] | undefined;
    CommandType?: CommandTypes;
    TextBlockName?: string | undefined;
    Tooltip?: string | undefined;
    TooltipText?: string | undefined;
    Text?: string | undefined;
    Icon?: string | undefined;
    Link?: string | undefined;
    LinkMode?: string | undefined;
    BackgroundColor?: string | undefined;
    ForegroundColor?: string | undefined;
    HorizontalAlignment?: HorizontalAlignment;
    readonly ComboboxItems?: CommandComboboxItem[] | undefined;
    SelectedComboboxItem?: CommandComboboxItem;
    Width?: string | undefined;
    HtmlTemplate?: string | undefined;
    Row?: number;
    CssClass?: string | undefined;
}

export interface CommandCell {
    Row?: number;
    Col?: number;
}

export interface CommandComboboxItem {
    Value?: string | undefined;
    Text?: string | undefined;
}

export interface PageTokenParameter {
    /** Gets or sets pageToken */
    PageToken?: string | undefined;
}

/** Service-Parameter which contains the context Info. */
export interface ContextParameter extends PageTokenParameter {
    /** Gets or sets parameters from the query string. */
    QueryParameters?: { [key: string]: any; } | undefined;
    /** Gets or sets application parameters. */
    ApplicationParameters?: { [key: string]: any; } | undefined;
}

/** Service-Parameter which contains the Context for Commands. */
export interface CommandContextParameter extends ContextParameter {
    /** Gets or sets filter-Parameters of all Filters 2. */
    Filter?: { [key: string]: any; } | undefined;
    /** Gets or sets the guid of the node. */
    RowGuid?: string | undefined;
    /** Gets or sets the guid of the parent node. */
    ParentRowGuid?: string | undefined;
}

export interface CommandContextTreeParameter extends CommandContextParameter {
    /** Gets or sets the guid fo the commandprep node. */
    FromRowGuid?: string | undefined;
    /** Gets or sets the guid fo the commandprep parent node. */
    FromParentRowGuid?: string | undefined;
}

export interface CommandDataRowContextParameter extends CommandContextParameter {
    /** Gets or sets the current datarow. */
    DataRow?: { [key: string]: any; } | undefined;
}

export interface CommandMultipleDataRowContextParameter extends CommandContextParameter {
    /** Gets or sets the list of changed datarows. */
    DataRows?: { [key: string]: any; }[] | undefined;
}

export interface CommandOption {
    /** Gets or sets number of Items to be taken (=PageSize). */
    Take?: number | undefined;
    /** Gets or sets number of Items to be skipped. */
    Skip?: number | undefined;
    /** Gets or sets sorting Definition. */
    Sort?: SortItem[] | undefined;
    /** Gets or sets grouping Definition. */
    Group?: GroupItem[] | undefined;
    /** Gets or sets list of aggregate definitions. */
    Aggregate?: AggregateItem[] | undefined;
    /** Gets or sets filter Definition */
    Filter?: any | undefined;
    /** Gets or sets a value indicating whether true if the data should be fetched from the dataSource instead of the cache. */
    ReloadFromDataSource?: boolean;
}

/** Parameters for a command request. */
export interface CommandRequestParameter extends CommandContextParameter {
    Options?: CommandOption;
}

export interface CommandResult extends BaseResult {
    /** Gets or sets total count of items available (used for calculating the amount of pages). */
    "odata.count"?: number | undefined;
    /** Gets or sets result values. */
    value?: any[] | undefined;
    /** Gets or sets returns values for the first page. */
    aggregateresults?: { [key: string]: { [key: string]: any; }; } | undefined;
}

/** 1 = ReloadAll 2 = InsertRowBelow 3 = InsertRowAbove 4 = InsertColumnLeft 5 = InsertColumnRight 6 = DeleteRow 7 = DeleteColumn 8 = ReloadCached 9 = WindowClose 10 = File 11 = Modify 12 = Script */
export enum CommandResultTypes {
    ReloadAll = 1,
    InsertRowBelow = 2,
    InsertRowAbove = 3,
    InsertColumnLeft = 4,
    InsertColumnRight = 5,
    DeleteRow = 6,
    DeleteColumn = 7,
    ReloadCached = 8,
    WindowClose = 9,
    File = 10,
    Modify = 11,
    Script = 12,
}

/** 1 = Link 2 = Command 3 = Combobox 4 = Custom 5 = Search */
export enum CommandTypes {
    Link = 1,
    Command = 2,
    Combobox = 3,
    Custom = 4,
    Search = 5,
}

/** Client definition for context menu items. */
export interface ContextMenuDefinition {
    /** Gets or sets id of ContextMenuEntry */
    ContextMenuID?: number;
    /** Gets or sets rangeColumnname */
    RangeColumnName?: string | undefined;
    /** Gets or sets value for Range From */
    RangeFrom?: number | undefined;
    /** Gets or sets value for Range To */
    RangeTo?: number | undefined;
    /** Gets or sets represents Caption */
    Caption?: string | undefined;
    /** Gets or sets link for ContextMenuEntry */
    Link?: string | undefined;
    /** Gets or sets linkMode describes how Link should be opened (Window f.e) */
    LinkMode?: string | undefined;
}

/** Definition of a single control. */
export interface ControlDefinition {
    /** Gets or sets iD of the control. This value is unique. */
    ControlID: number;
    /** Gets or sets type of the control. */
    ControlTypeID: number;
    ControlType?: GridControlTypes;
    /** Gets or sets iD of the Grid where the control belongs to. */
    GridID?: number;
    /** Gets or sets iD of the DMS-Command which should be executed on click. */
    CommandID?: number | undefined;
    /** Gets or sets name of the column which contains the value. */
    ValueColumnName?: string | undefined;
    /** Gets or sets name of the column which contains the text. */
    TextColumnName?: string | undefined;
    /** Gets or sets name of the filter parameter for filter controls. */
    FilterParameterName?: string | undefined;
    /** Gets or sets true if control is visible in add mode. */
    OnAdd?: boolean | undefined;
    /** Gets or sets true if control is visible in edit mode. */
    OnEdit?: boolean | undefined;
    /** Gets or sets true if control is visible in display mode. */
    OnDisplay?: boolean | undefined;
    /** Gets or sets true if control is editable in add mode. */
    OnAddEditable?: boolean | undefined;
    /** Gets or sets true if control is editable in edit mode. */
    OnEditEditable?: boolean | undefined;
    /** Gets or sets javaScript to be executed on click or change (depending on controltype). */
    Script?: string | undefined;
    /** Gets or sets javaScript to be executed after execution of the command. */
    AfterExecuteScript?: string | undefined;
    /** Gets or sets javaScript to be executed before execution of the command. */
    BeforeExecuteScript?: string | undefined;
    /** Gets or sets javaScript to be executed on page load. */
    LoadScript?: string | undefined;
    /** Gets or sets javaScript to be executed on focus lost on the control. */
    LostFocusScript?: string | undefined;
    /** Gets or sets the path to the icon. */
    Icon?: string | undefined;
    /** Gets or sets link which should be opened on click. */
    Link?: string | undefined;
    /** Gets or sets mode for the popup. */
    LinkMode?: string | undefined;
    /** Gets or sets a value indicating whether true if GroupSeparator should be rendered for number controls. */
    GroupSeparator?: boolean;
    /** Gets or sets amount of decimal digits for number controls. */
    DecimalDigits?: number | undefined;
    /** Gets or sets minimum value for number controls. */
    MinValue?: number | undefined;
    /** Gets or sets maximum value for number controls. */
    MaxValue?: number | undefined;
    /** Gets or sets a value indicating whether true if value should be displayed with percent symbol. */
    DisplayAsPercent?: boolean;
    /** Gets or sets caption for control. */
    Caption?: string | undefined;
    /** Gets or sets width of control. */
    Width?: string | undefined;
    /** Gets or sets height of control. */
    Height?: string | undefined;
    /** Gets or sets a value indicating whether true if control is disabled on render. */
    Disabled?: boolean;
    /** Gets or sets default value for the control. Can contain JavaScript functions (needs to be resolved). */
    DefaultValue?: string | undefined;
    /** Gets or sets items per request for virtual controls. */
    ItemsPerRequest?: number;
    /** Gets or sets a value indicating whether true if data should be loaded asynchronously. */
    LoadDataAsynchronously?: boolean;
    /** Gets or sets list of controls which this control is dependent on. */
    DependencyControlIds?: number[] | undefined;
    /** Gets or sets confirmationtext on click. */
    ConfirmText?: string | undefined;
    /** Gets or sets error message for required control in add mode. */
    AddRequiredText?: string | undefined;
    /** Gets or sets error message for required control in edit mode. */
    EditRequiredText?: string | undefined;
    /** Gets or sets iD of the GridCommand. */
    GridCommandID?: number | undefined;
    /** Gets or sets value column of GridCommand. */
    DependentValueColumnName?: string | undefined;
    /** Gets or sets tooltip TextBlock. */
    ToolTip?: string | undefined;
    /** Gets or sets a value indicating whether true if the current value (from value-binding) should be used as tooltip. */
    UseValueColumnToolTip?: boolean;
    /** Gets or sets prerendered JavaScript condition for control visibility in a row. */
    VisibilityCondition?: string | undefined;
    /** Gets if the database value is null, this value should be rendered. */
    readonly ReplaceNullValue?: string | undefined;
    /** Gets a value indicating whether true if the control should add a null value. */
    readonly InsertNullValue?: boolean;
    /** Gets a value indicating whether true if button is a submitbutton (=columnType == submit). */
    readonly IsSubmit?: boolean;
    /** Gets name of the text column for command value. */
    readonly CommandTextColumnName?: string | undefined;
    /** Gets name of the value column for command value. */
    readonly CommandValueColumnName?: string | undefined;
    /** Gets or sets name of an additional optional binding column. */
    AdditionalBindingColumnName?: string | undefined;
    /** Gets or sets contains multiple columns for this control which should be rendered in a list. */
    DataColumns?: GridControlDataColumnDefinition[] | undefined;
    /** Gets or sets the mask for the maskedtextbox. */
    Mask?: string | undefined;
    /** Gets or sets a value indicating whether true if input should be rendered as password field. */
    IsPassword?: boolean;
    /** Gets or sets contains the name of the applicationparameter, which will contain the controls value. */
    ApplicationParameter?: string | undefined;
    /** Gets or sets name of the radio group if control is part of radio group. */
    RadioGroup?: string | undefined;
    /** Gets or sets a value indicating whether true if required fields need to be checked before execution (click or command). */
    CheckRequiredFields?: boolean;
    /** Gets or sets maximum length. */
    MaxLength?: number | undefined;
    /** Gets or sets a value indicating whether true if button is DefaultButton. */
    IsDefaultButton?: boolean;
    /** Gets or sets a value indicating whether true if AutoWidth is enabled. */
    AutoWidth?: boolean;
    /** Gets or sets list of ContextMenuDefinitions. */
    ContextMenuDefinitions?: ContextMenuDefinition[] | undefined;
    /** Gets or sets a value indicating whether true if the control should trim the entered text. */
    Trim?: boolean;
    /** Gets or sets list of FormatDefinitions. */
    FormatDefinitions?: FormatDefinition[] | undefined;
    /** Gets or sets a value indicating whether true if the content should be html encoded. */
    EncodeHtml?: boolean;
    /** Gets or sets css class configured for this control. */
    CssClass?: string | undefined;
    /** Gets or sets rangeColumnName for visibility check */
    RangeColumnName?: string | undefined;
    /** Gets or sets rangefrom for visibility check */
    RangeFrom?: number | undefined;
    /** Gets or sets rangeto for visibility check */
    RangeTo?: number | undefined;
    /** Gets or sets true if Range Algorithm should be "inverted" */
    RangeInvert?: boolean | undefined;
    /** Gets or sets additional output parameter 1 for command execution. */
    AdditionalOutputParameter1Name?: string | undefined;
    /** Gets or sets additional output parameter 2 for command execution. */
    AdditionalOutputParameter2Name?: string | undefined;
    /** Gets or sets list of customisations which need to be applied on the client. */
    Customisations?: CustomisationDefinition[] | undefined;
    /** Gets or sets columnName for conditional editable. */
    EditRangeColumnName?: string | undefined;
    /** Gets or sets rangeFrom for conditional editable. */
    EditRangeFrom?: number | undefined;
    /** Gets or sets rangeTo for conditional editable. */
    EditRangeTo?: number | undefined;
    /** Gets or sets rangeInvert for conditional editable. */
    EditRangeInvert?: boolean | undefined;
}

/** Definition for a customisation which has to be applied on the client. */
export interface CustomisationDefinition {
    /** Gets columnName of the datarow. */
    readonly RangeColumnName?: string | undefined;
    /** Gets compare to range from. */
    readonly RangeFrom?: number | undefined;
    /** Gets compare to range to. */
    readonly RangeTo?: number | undefined;
    /** Gets value to be set if range applies. */
    readonly Value?: string | undefined;
    /** Gets property to be set if range applies. */
    readonly Property?: string | undefined;
}

/** Definition of a form column. */
export interface DashboardColumnDefinition extends BaseColumnDefinition {
    /** Gets or sets fixed column width. */
    Width?: string | undefined;
    /** Gets or sets fixed column height. */
    Height?: string | undefined;
    /** Gets or sets a value indicating whether true if column is frozen on initial load. */
    IsFrozen?: boolean;
    /** Gets or sets the row of the dashboard item. */
    Row?: string | undefined;
    /** Gets or sets the column of the dashboard item. */
    Column?: string | undefined;
}

/** Definition of a form. */
export interface DashboardDefinition extends BaseGridDefinition {
    /** Gets or sets list of form columns. */
    Columns?: DashboardColumnDefinition[] | undefined;
    /** Gets or sets a value indicating whether true if one is allowed to reorder columns */
    CanReorderColumns?: boolean;
    /** Gets or sets a value indicating whether true if one is allowed to hide columns */
    CanHideColumns?: boolean;
    /** Gets or sets a value indicating whether true if one is allowed to resize columns */
    CanResizeColumns?: boolean;
}

/** Contains Odata QueryParams (for partial data requests) */
export interface DataRequestOption {
    /** Gets or sets (optional) ID of the requesting Control. */
    ControlID?: number | undefined;
    /** Gets or sets number of Items to be taken (=PageSize). */
    Take?: number | undefined;
    /** Gets or sets number of Items to be skipped. */
    Skip?: number | undefined;
    /** Gets or sets value to be searched (usually selectedValue of binding). */
    SearchValue?: string[] | undefined;
    /** Gets or sets text to be searched (usually entered text by user). */
    SearchText?: string | undefined;
    FilterOperator?: FilterOperator;
    /** Gets or sets a value indicating whether true if the data should be fetched from the dataSource instead of the cache. */
    ReloadFromDataSource?: boolean;
}

export interface DatabaseImageResult extends BaseResult {
    /** Gets or sets the image content. */
    Content?: string | undefined;
    /** Gets or sets the image content type. */
    ContentType?: string | undefined;
}

export interface DatasheetCell {
    IsEditable?: boolean;
    IsSaved?: boolean;
    Formula?: any | undefined;
    Value?: any | undefined;
    BackgroundColor?: string | undefined;
    ForegroundColor?: string | undefined;
    IsBold?: boolean;
    IsItalic?: boolean;
    CellType?: CellTypes;
    TextHorizontalAlign?: string | undefined;
    TextVerticalAlign?: string | undefined;
    Format?: string | undefined;
    ComboboxName?: string | undefined;
    RowIndex?: number | undefined;
    ColumnIndex?: number | undefined;
    Tooltip?: string | undefined;
    Validation?: DatasheetCellValidation;
    TargetID?: string | undefined;
    Icon?: string | undefined;
    Link?: string | undefined;
    LinkMode?: string | undefined;
    Script?: string | undefined;
    CommandId?: string | undefined;
    Caption?: string | undefined;
    Comment?: string | undefined;
}

export interface DatasheetCellRef {
    RowIndex?: number;
    ColumnIndex?: number;
    Value?: any | undefined;
    Formula?: string | undefined;
}

export interface DatasheetCellValidation {
    Type?: DatasheetCellValidationType;
    ComparerType?: DatasheetCellValidationComparerType;
    DataType?: DatasheetCellValidationDataType;
    From?: string | undefined;
    To?: string | undefined;
    ShowButton?: boolean;
    AllowNulls?: boolean;
    ErrorMessage?: string | undefined;
    ErrorTitle?: string | undefined;
}

/** 0 = GreaterThan 1 = LessThan 2 = Between 3 = EqualTo 4 = NotEqualTo 5 = GreaterThanOrEqualTo 6 = LessThanOrEqualTo 7 = NotBetween 8 = Custom */
export enum DatasheetCellValidationComparerType {
    GreaterThan = 0,
    LessThan = 1,
    Between = 2,
    EqualTo = 3,
    NotEqualTo = 4,
    GreaterThanOrEqualTo = 5,
    LessThanOrEqualTo = 6,
    NotBetween = 7,
    Custom = 8,
}

/** 0 = Date 1 = Text 2 = Number 3 = List 4 = Custom */
export enum DatasheetCellValidationDataType {
    Date = 0,
    Text = 1,
    Number = 2,
    List = 3,
    Custom = 4,
}

/** 0 = Warning 1 = Reject */
export enum DatasheetCellValidationType {
    Warning = 0,
    Reject = 1,
}

export interface DatasheetCommandResult {
    Type?: CommandResultTypes;
    ChangeClientCells?: PlanningsheetCell[] | undefined;
    ChangeClientCellsDatasheet?: DatasheetCell[] | undefined;
    Cells?: DatasheetCell[] | undefined;
    FileContentBase64?: string | undefined;
    FileType?: string | undefined;
    FileName?: string | undefined;
    Script?: string | undefined;
}

export interface DatasheetDefinition {
    ID?: string | undefined;
    Cells?: DatasheetCell[][] | undefined;
    Options?: DatasheetOptions;
}

export interface DatasheetDefinitionContextParameter {
    ID?: string | undefined;
    RepositoryName?: string | undefined;
    Cached?: boolean;
    Filter?: { [key: string]: any; } | undefined;
    ParentRowGuid?: string | undefined;
    RowGuid?: string | undefined;
    QueryParameters?: { [key: string]: any; } | undefined;
    ApplicationParameters?: { [key: string]: any; } | undefined;
}

export interface DatasheetOptions {
    Height?: number | undefined;
    TitleTextBlockName?: string | undefined;
    RowHeights?: number[] | undefined;
    ColumnWidths?: number[] | undefined;
    IsExpanded?: boolean;
    MergedCells?: string[] | undefined;
    Commands?: Command[] | undefined;
    readonly CommandsByRow?: Command[][] | undefined;
    ShowGridLines?: boolean;
    FrozenRows?: number | undefined;
    FrozenColumns?: number | undefined;
    SelectLists?: { [key: string]: any[]; } | undefined;
}

export interface DownloadFile extends BaseResult {
    File?: string | undefined;
    FileName?: string | undefined;
    MimeType?: string | undefined;
}

export interface DownloadFileRequest extends PageTokenParameter {
    FileName?: string | undefined;
    IeSessionGuid?: string;
}

export interface DropDownCommandResult extends CommandResult {
    readonly value?: any[] | undefined;
    /** Gets or sets for Combobox-Data: Index which should be selected. */
    selectedIndex?: number[] | undefined;
}

/** Request parameters for requesting a single combobox. */
export interface DropDownRequestParameter extends CommandDataRowContextParameter {
    DataRequestOption?: DataRequestOption;
}

export interface Environment extends BaseResult {
    /** Gets or sets language code i.e. "D", "E". */
    LanguageCode?: string | undefined;
    /** Gets or sets culture i.e. "de-AT", "en-US". */
    Culture?: string | undefined;
    /** Gets or sets format for DateTime-Controls. */
    DateTimeFormat?: string | undefined;
    /** Gets or sets format for Date-Controls. */
    DateFormat?: string | undefined;
    /** Gets or sets format for Time-Controls. */
    TimeFormat?: string | undefined;
    /** Gets or sets groupSeparator for Number-Controls, i.e. "." for german. */
    NumberFormatGroupSeparator?: string | undefined;
    /** Gets or sets commaSeparator for Number-Controls, i.e. "," for german. */
    NumberFormatCommaSeparator?: string | undefined;
    /** Gets or sets configured Browser Title. */
    BrowserTitle?: string | undefined;
    /** Gets or sets a value indicating whether true if missing TextBlocks should be generated */
    AutoCreateTextBlocksIfMissing?: boolean;
    /** Gets or sets name of the current theme. */
    Theme?: string | undefined;
    /** Gets or sets a value indicating whether notifications are enabled */
    IsNotificationEnabled?: boolean;
    /** Gets or sets a value indicating whether the global search is enabled. */
    IsGlobalSearchEnabled?: boolean;
    /** Gets or sets a value indicating whether the toast notifications are enabled. */
    IsToastEnabled?: boolean;
    /** Gets or sets path for all images. */
    ImagePath?: string | undefined;
    /** Gets or sets list of file extensions which are allowed for the file upload control. */
    FileUploadExtensionWhitelist?: string[] | undefined;
    /** Gets or sets the name of the mapping which is displayed in the menu. */
    MenuMappingName?: string | undefined;
    /** Gets or sets the unique name of the application on this server. */
    UniqueApplicationName?: string | undefined;
    /** Gets or sets the timezone of the webserver. */
    ServerTimeZone?: string | undefined;
    /** Gets or sets the timezone of the client.
Not set in server code. */
    ClientTimeZone?: string | undefined;
    ApplicationParameters?: { [key: string]: string; } | undefined;
    /** Gets or sets the instrumentation key of app insights if configured. */
    AppInsightsInstrumentationKey?: string | undefined;
    UserStartPage?: string | undefined;
    /** Gets or sets a value indicating whether gets or sets wether the page content textblock should be shown. */
    EnablePageContentTextBlock?: boolean;
    /** Gets or sets a value indicating whether gets or sets wether the edit textblock button should be shown. */
    HasTextBlockButton?: boolean;
    /** Gets or sets a value indicating whether the local login is enabled. */
    IsLocalLoginEnabled?: boolean;
    /** Gets or sets the path to the main logo. */
    LogoPath?: string | undefined;
    /** Gets or sets the path to the small logo (mini-menu). */
    LogoPathSmall?: string | undefined;
}

export interface ExecuteCommandParameter extends DatasheetDefinitionContextParameter {
    Row?: number;
    Col?: number;
    Cells?: DatasheetCellRef[] | undefined;
    CommandID?: string | undefined;
    Value?: string | undefined;
}

/** Class representing a column to be exported. */
export interface ExportColumn {
    /** Gets or sets the name of the columnm. */
    Name?: string | undefined;
    /** Gets or sets a value indicating whether gets or sets wether the column is hidden. */
    IsHidden?: boolean;
    /** Gets or sets the column display index. */
    DisplayIndex?: number;
}

/** Service-Parameter which contains the Context for Exports. */
export interface ExportContextParameter extends CommandContextParameter {
    /** Gets or sets category for TextBlocks. */
    TextBlockCategory?: string | undefined;
    /** Gets or sets id of the grid to export. */
    GridID?: number;
    /** Gets or sets id of the filter to export. */
    FilterID?: number | undefined;
    Options?: CommandOption;
    /** Gets or sets the timezone in IANA notation. */
    TimezoneIANA?: string | undefined;
    Columns?: ExportColumn[] | undefined;
}

export interface ExportParameter {
    ParameterName?: string | undefined;
    TypeCode?: string | undefined;
    Description?: string | undefined;
    ParameterValue?: string | undefined;
}

export interface ExportResult extends BaseResult {
    File?: string | undefined;
}

export interface ExportType extends BaseResult {
    ExportTypeID?: number;
    Description?: string | undefined;
    Parameters?: ExportParameter[] | undefined;
}

/** Service-Parameter which contains the file upload info. */
export interface FileUploadParameter extends PageTokenParameter {
    /** ID of the FileUploadControl. */
    ControlID?: number;
}

/** 0 = CONTAINS 1 = STARTS_WITH */
export enum FilterOperator {
    CONTAINS = 0,
    STARTS_WITH = 1,
}

/** The definition for a fixed value (ie. default value of a control) which needs to be handled and resent by the client. */
export interface FixedValueDefinition {
    /** Gets or sets name of the column (ie. ValueColumnName, FilterParameterName or ApplicationParameterName). */
    ColumnName?: string | undefined;
    /** Gets or sets the configured value. This may contain scripts or parameter replacements, so resolving is needed before using. */
    Value?: string | undefined;
    /** Gets or sets the ID of the control. */
    ControlID?: number;
    /** Gets or sets the type ID of the control. */
    ControlTypeID?: number;
}

/** Definition of a form column. */
export interface FormColumnDefinition extends BaseColumnDefinition {
    /** Gets or sets columntype. */
    ColumnTypeID: number;
    /** Gets or sets fixed column width. */
    ColumnWidth?: string | undefined;
    /** Gets or sets a value indicating whether get the setting for hiding the column header. */
    HideColumnHeader?: boolean;
}

/** Definition of a form. */
export interface FormDefinition extends BaseGridDefinition {
    /** Gets or sets list of submitbuttons. */
    Submitbuttons?: FormColumnDefinition[] | undefined;
    /** Gets or sets list of normal buttons. */
    Buttons?: FormColumnDefinition[] | undefined;
    /** Gets or sets list of form columns. */
    Columns?: FormColumnDefinition[][] | undefined;
    /** Gets or sets the individual widths for each column if available. */
    ColumnWidths?: string[] | undefined;
    /** Gets list of form groups. */
    readonly Groups?: GroupDefinition[] | undefined;
    /** Gets list of form tabs. */
    readonly Tabs?: TabDefinition[] | undefined;
    /** Gets a value indicating whether true if grids should be cleared on filter change. */
    readonly ClearGridsOnChange?: boolean;
    /** Gets buttonplacement (left, right, center). */
    readonly ButtonPlacementID?: number;
}

/** Format Definition for Controls and Grids. */
export interface FormatDefinition {
    /** Gets or sets value range from. */
    RangeFrom?: number | undefined;
    /** Gets or sets value range to. */
    RangeTo?: number | undefined;
    /** Gets or sets value comparison. */
    Compare?: string | undefined;
    /** Gets or sets name of the column. */
    ColumnName?: string | undefined;
    /** Gets or sets css class which should be assigned. */
    CssClass?: string | undefined;
}

export interface GlobalSearch {
    Text?: string | undefined;
    Description?: string | undefined;
    Link?: string | undefined;
    Script?: string | undefined;
    Category?: string | undefined;
}

export interface GlobalSearchParameter extends PageTokenParameter {
    Text?: string | undefined;
    CurrentUrl?: string | undefined;
    CurrentParameters?: string | undefined;
}

export interface GlobalSearchResult extends BaseResult {
    Value?: GlobalSearch[] | undefined;
}

/** Definition of a grid column. */
export interface GridColumnDefinition extends BaseColumnDefinition {
    /** Gets or sets type of column. */
    ColumnTypeID: number;
    ColumnType?: ColumnTypes;
    /** Gets or sets a value indicating whether true if sorting is allowed for this column. */
    SortAllowed?: boolean;
    /** Gets or sets fixed width of column. */
    ColumnWidth?: string | undefined;
    /** Gets or sets a value indicating whether true if column is frozen on initial load. */
    IsFrozen?: boolean;
    /** Gets or sets name of grouping column. */
    GroupColumnName?: string | undefined;
    /** Gets or sets a value indicating whether true if word breaking should be enabled. */
    UseWordBreaking?: boolean;
    /** Gets or sets a value indicating whether true if ellipsis should be enabled */
    UseEllipsis?: boolean;
    /** Gets or sets filterType */
    ColumnFilterTypeID?: number | undefined;
    /** Gets or sets control ID of Filter Control */
    ColumnFilterControlID?: number | undefined;
    /** Gets or sets aggregate function for grouping. */
    AggregateFunctionID?: number | undefined;
    /** Gets or sets control for aggregate function. */
    AggregateControlID?: number | undefined;
    /** Gets or sets textBlock for group footer template. */
    GroupFooterTextBlockName?: string | undefined;
    /** Gets or sets iD of the column group. */
    GroupID?: number | undefined;
    /** Gets or sets name of the group header. */
    GroupHeader?: string | undefined;
    /** Gets or sets the media query which has to be true to show this column. */
    VisibleMedia?: string | undefined;
}

/** Definition for a GridCommand. */
export interface GridCommandDefinition {
    /** Gets or sets id of the GridCommand. */
    GridCommandID: number;
    /** Gets or sets id of the dms-command. */
    DependentValueCommandID: number;
    /** Gets or sets list of control ids which are input for this command. */
    InputControlIDs: number[];
}

/** Contains data for a single GridCommand */
export interface GridCommandOption {
    /** Gets or sets iD of the GridCommand-Definition. */
    GridCommandID?: number;
    /** Gets or sets iD of the actual DMSCommand, which will be executed. */
    DependentValueCommandID?: number;
}

/** Parameters for the execution of multiple GridCommands at once. */
export interface GridCommandRequestParameter extends CommandDataRowContextParameter {
    /** Gets or sets gridCommands which will be executed. */
    GridCommandOptions?: GridCommandOption[] | undefined;
}

/** Definition of a additional data columns (used in list controls). */
export interface GridControlDataColumnDefinition {
    /** Gets or sets column name in command. */
    ColumnName: string;
    /** Gets or sets textblock for header. */
    Caption?: string | undefined;
    /** Gets or sets the width of the column. */
    Width?: string | undefined;
}

/** 0 = Undefined 1 = Text 2 = Number 3 = Date 4 = Checkbox 5 = List 6 = SelectDialog 7 = Image 8 = TextBlock 9 = HiddenText 10 = HiddenDate 11 = DateTime 12 = Time 13 = TextTextBlock 14 = MaskedTextBox 15 = ComboBox 20 = HtmlEditor 21 = FileUpload 23 = ContextMenu 24 = RtfEditor 25 = DatabaseImage 26 = ThreeStateCheckbox 27 = ColorPicker 28 = Custom 29 = MultiSelect 30 = AutoComplete 31 = PeoplePicker 32 = DateTimeNoTimeZone 33 = UserPicker 101 = Edit 102 = Cancel 103 = Add 104 = Update 105 = Delete 106 = Command 107 = Link 108 = SelectButton 109 = MultiPageUpdate 110 = DatasetCommand 111 = ColumnSelectorCommand */
export enum GridControlTypes {
    Undefined = 0,
    Text = 1,
    Number = 2,
    Date = 3,
    Checkbox = 4,
    List = 5,
    SelectDialog = 6,
    Image = 7,
    TextBlock = 8,
    HiddenText = 9,
    HiddenDate = 10,
    DateTime = 11,
    Time = 12,
    TextTextBlock = 13,
    MaskedTextBox = 14,
    ComboBox = 15,
    HtmlEditor = 20,
    FileUpload = 21,
    ContextMenu = 23,
    RtfEditor = 24,
    DatabaseImage = 25,
    ThreeStateCheckbox = 26,
    ColorPicker = 27,
    Custom = 28,
    MultiSelect = 29,
    AutoComplete = 30,
    PeoplePicker = 31,
    DateTimeNoTimeZone = 32,
    UserPicker = 33,
    Edit = 101,
    Cancel = 102,
    Add = 103,
    Update = 104,
    Delete = 105,
    Command = 106,
    Link = 107,
    SelectButton = 108,
    MultiPageUpdate = 109,
    DatasetCommand = 110,
    ColumnSelectorCommand = 111,
}

/** Definition for a grid. */
export interface GridDefinition extends BaseGridDefinition {
    /** Gets or sets a value indicating whether true if the user is allowed to group by columns. */
    CanGroupByColumns?: boolean;
    /** Gets or sets a value indicating whether true if the user is allowed to freeze columns. */
    CanFreezeColumns?: boolean;
    /** Gets or sets a value indicating whether true if the user is allowed to hide columns. */
    CanHideColumns?: boolean;
    /** Gets or sets a value indicating whether true if the user is allowed to reorder columns. */
    CanReorderColumns?: boolean;
    /** Gets or sets a value indicating whether true if the user is allowed to resize columns. */
    CanResizeColumns?: boolean;
    /** Gets or sets a value indicating whether true if the user is allowed to sort by multiple columns. */
    CanSortByMultipleColumns?: boolean;
    /** Gets or sets amount of rows to be shown per page. */
    PageSize?: number | undefined;
    /** Gets or sets a value indicating whether true if the add line should be shown on render. */
    ShowAddLineImmediately?: boolean;
    /** Gets list of grid columns. */
    readonly Columns?: GridColumnDefinition[] | undefined;
    /** Gets a value indicating whether true if the refresh button should be shown. */
    readonly ShowRefreshButton?: boolean;
    /** Gets or sets get the configured datarow order definition. */
    Order?: GridOrderDefinition[] | undefined;
    /** Gets or sets list of FormatDefinitions */
    FormatDefinitions?: FormatDefinition[] | undefined;
    /** Gets or sets list of AddLinks */
    AddLinks?: AddLinkDefinition[] | undefined;
    /** Gets or sets a value indicating whether true if exporting is enabled. */
    ReportEnabled?: boolean;
    /** Gets or sets the name of the primary key column.
Only relevant for TreeGrid. */
    PrimaryKeyColumnName?: string | undefined;
    /** Gets or sets the column name which indicates, that this node has child nodes.
Only relevant for TreeGrid. */
    HasChildNodesColumnName?: string | undefined;
}

/** Definition of grid ordering. */
export interface GridOrderDefinition {
    /** Gets or sets columnname which should be ordered. */
    ColumnName: string;
    /** Gets or sets a value indicating whether true if column should be ordered descending. */
    Descending: boolean;
    /** Gets or sets a value indicating whether true if the order is required, so the user cannot remove the order. */
    Required: boolean;
}

/** GridScriptDefinition for Client */
export interface GridScriptDefinition {
    /** Gets or sets represents the script */
    Script?: string | undefined;
}

/** 2 = Form 3 = Filter 5 = Tree 6 = Grid 7 = EasyEdit 8 = Dashboard 9 = TreeGrid */
export enum GridTypes {
    Form = 2,
    Filter = 3,
    Tree = 5,
    Grid = 6,
    EasyEdit = 7,
    Dashboard = 8,
    TreeGrid = 9,
}

/** Definition of a form group- */
export interface GroupDefinition {
    /** Gets or sets id of the group. */
    GroupID: number;
    /** Gets or sets group header Textblock name. */
    GroupHeader: string;
    /** Gets or sets form columns in this group. */
    Columns?: FormColumnDefinition[][] | undefined;
    /** Gets or sets the individual widths for each column if available. */
    ColumnWidths?: string[] | undefined;
}

/** Specifies a grouping description. */
export interface GroupItem {
    /** Gets or sets name of the grid column. */
    ColumnName?: string | undefined;
    /** Gets or sets database-Field to be grouped */
    Field?: string | undefined;
    /** Gets or sets the grouping direction ("asc" or "desc") */
    Dir?: string | undefined;
    /** Gets or sets specified aggregates for this group. */
    Aggregates?: AggregateItem[] | undefined;
}

/** 0 = Left 1 = Center 2 = Right */
export enum HorizontalAlignment {
    Left = 0,
    Center = 1,
    Right = 2,
}

export interface IfcExportRequest extends PageTokenParameter {
    /** Gets or sets values of the custom parameters entered by the user. */
    ParameterValues?: { [key: string]: string; } | undefined;
}

export interface IfcExportResult {
    IESessionGUID?: string | undefined;
    FileName?: string | undefined;
}

export interface ImportParameter {
    ParameterName?: string | undefined;
    Description?: string | undefined;
    ParameterValue?: string | undefined;
}

/** Parameter for import. */
export interface ImportRequest extends PageTokenParameter {
    /** Gets or sets a value indicating whether true if the upload should only be checked and not imported. */
    UploadOnly?: boolean;
    /** Gets or sets values of the custom parameters entered by the user. */
    ParameterValues?: { [key: string]: string; } | undefined;
}

/** Response for import request. */
export interface ImportResult {
    /** Gets or sets number of errors. */
    ErrorCount?: number;
    /** Gets or sets error Message. */
    MessageString?: string | undefined;
    /** Gets or sets textBlock for result message. */
    ResultTextBlockName?: string | undefined;
    /** Gets or sets amount of lines imported. */
    LinesImported?: number;
    /** Gets or sets amount of lines with error. */
    LinesWithError?: number;
    /** Gets or sets amount of line error count. */
    LinesErrorCount?: number;
    /** Gets or sets amount of lines total. */
    LinesTotal?: number;
    /** Gets or sets iESessionGUID-List for result grid. */
    IESessionGUID?: string | undefined;
}

export interface ImportType extends BaseResult {
    ImportTypeID?: number;
    Description?: string | undefined;
    FileNeeded?: boolean;
    ParameterDMSMappingName?: string | undefined;
    Parameters?: ImportParameter[] | undefined;
}

export interface Language extends BaseResult {
    LanguageCode?: string | undefined;
    LanguageDescription?: string | undefined;
}

/** Definition of a mapping. */
export interface MappingDefinition {
    /** Gets or sets get or sets the name of the mapping. */
    MappingName?: string | undefined;
    /** Gets or sets the list of grid definitions. */
    GridDefinitions?: BaseGridDefinition[] | undefined;
    /** Gets or sets the list of custom mapping configs. */
    UserMappingConfig?: UserMappingConfigDefinition[] | undefined;
    /** Gets or sets a value indicating whether get or sets wether the user is allowed to save user system user grid configs. */
    AllowSystemMappingGridConfig?: boolean;
    /** Gets or sets a value indicating whether gets or sets wether the mapping is configured for user grid configs. */
    IsMappingGridConfig?: boolean;
}

/** 0 = FilterAndGrids 1 = GridsOnly 2 = FiltersOnly */
export enum MappingDisplayTypes {
    FilterAndGrids = 0,
    GridsOnly = 1,
    FiltersOnly = 2,
}

export interface Menu extends BaseResult {
    Value?: MenuItem[] | undefined;
}

export interface MenuItem {
    /** Gets or sets menu Url */
    Href?: string | undefined;
    /** Gets or sets mode for window.open */
    HrefMode?: string | undefined;
    /** Gets or sets menutext. */
    MenuText?: string | undefined;
    TextBlockModule?: string | undefined;
    /** Gets or sets a value indicating whether true if url should be opened in new window. */
    OpenInNewWindow?: boolean;
    /** Gets or sets child items. */
    Items?: MenuItem[] | undefined;
    /** Gets or sets menu Icon */
    Icon?: string | undefined;
}

/** Request parameters for requesting multiple controls. */
export interface MultipleControlRequestParameter extends CommandDataRowContextParameter {
    /** Gets or sets list of request options. */
    DataRequestOptions?: DataRequestOption[] | undefined;
}

export interface NumberFormat {
    GroupSeparator?: boolean;
    DecimalDigits?: number;
    DisplayAsPercent?: boolean;
}

export interface PageTokenResult {
    PageToken?: string | undefined;
}

export interface PlanningsheetCell {
    IsEditable?: boolean;
    IsSaved?: boolean;
    Value?: any | undefined;
    CellType?: CellTypes;
    CellStyleName?: string | undefined;
    CustomCellStyle?: CellStyle;
    RowIndex?: number | undefined;
    ColumnIndex?: number | undefined;
    Tooltip?: string | undefined;
    TooltipText?: string | undefined;
    Icon?: string | undefined;
    HasAdditionalIcon?: boolean;
    Link?: string | undefined;
    LinkMode?: string | undefined;
    Script?: string | undefined;
    Caption?: string | undefined;
    CommandId?: string | undefined;
    ChangeScript?: string | undefined;
    NumberFormat?: NumberFormat;
}

export interface PlanningsheetColumn {
    TitleTextBlock?: string | undefined;
    TitleText?: string | undefined;
    ColumnIndex?: number;
    Width?: string | undefined;
    CellStyleName?: string | undefined;
    HeaderHorizontalAlignment?: HorizontalAlignment;
    NumberFormat?: NumberFormat;
    Group?: PlanningsheetColumnGroup;
    IsHidden?: boolean;
    IsCollapseColumn?: boolean;
    HeaderColspan?: number;
    HideHeader?: boolean;
}

export interface PlanningsheetColumnGroup {
    TitleTextBlock?: string | undefined;
    GroupKey?: string | undefined;
    HeaderHorizontalAlignment?: HorizontalAlignment;
}

export interface PlanningsheetDefinition {
    Columns?: PlanningsheetColumn[] | undefined;
    Rows?: PlanningsheetRow[] | undefined;
    Options?: PlanningsheetOptions;
    FontSize?: string | undefined;
    CellStyles?: { [key: string]: CellStyle; } | undefined;
    NumberFormat?: NumberFormat;
    ShowColumnChooser?: boolean;
    readonly CollapseColumnIndex?: number;
    readonly GridScripts?: string[] | undefined;
    CssClass?: string | undefined;
}

export interface PlanningsheetDefinitionContextParameter {
    RepositoryName?: string | undefined;
    Cached?: boolean;
    Filter?: { [key: string]: any; } | undefined;
    ParentRowGuid?: string | undefined;
    RowGuid?: string | undefined;
    QueryParameters?: { [key: string]: any; } | undefined;
    ApplicationParameters?: { [key: string]: any; } | undefined;
}

export interface PlanningsheetOptions {
    readonly CommandsByRow?: Command[][] | undefined;
    FrozenColumns?: number | undefined;
    Virtualization?: boolean;
    NumberSelectOnFocus?: boolean;
}

export interface PlanningsheetRow {
    readonly RowIndex?: number;
    readonly ParentRowIndex?: number | undefined;
    IsCollapsible?: boolean;
    IsExpanded?: boolean;
    Cells?: PlanningsheetCell[] | undefined;
}

export interface PlanningsheetSetCellValueResult {
    ChangeClientCells?: PlanningsheetCell[] | undefined;
    Type?: SetCellValueResultTypes;
    ErrorMessage?: string | undefined;
}

export interface RefreshCacheProvider {
    /** Gets or sets name of the provider. */
    ProviderName?: string | undefined;
    /** Gets or sets name of the textblock at the RefreshCache-page. */
    TextBlockName?: string | undefined;
    /** Gets or sets list of success textblocks to be shown on the RefreshCache-page. */
    TextBlockNameSuccess?: string[] | undefined;
    /** Gets or sets a value indicating whether specify if the provider should be checked on default. */
    InitialChecked?: boolean;
}

export interface ReportContent extends BaseResult {
    Data?: string | undefined;
}

export interface ReportExecution {
    Parameters?: ReportParameterValue[] | undefined;
    QueryParameters?: { [key: string]: string; } | undefined;
}

export interface ReportExport extends BaseResult {
    FileName?: string | undefined;
    MimeType?: string | undefined;
    Data?: string | undefined;
}

export interface ReportParameter {
    Name?: string | undefined;
    Type?: GridControlTypes;
    Nullable?: boolean;
    AllowBlank?: boolean;
}

export interface ReportParameterValue {
    Name?: string | undefined;
    Value?: string | undefined;
}

export interface SetCellValueParameter extends DatasheetDefinitionContextParameter {
    Row?: number;
    Col?: number;
    Value?: any | undefined;
}

export interface SetCellValueResult {
    ChangeClientCells?: DatasheetCell[] | undefined;
    Type?: SetCellValueResultTypes;
    ErrorMessage?: string | undefined;
}

/** 0 = None 1 = Reload 2 = Modify */
export enum SetCellValueResultTypes {
    None = 0,
    Reload = 1,
    Modify = 2,
}

export interface SetMultipleCellValueParameter extends DatasheetDefinitionContextParameter {
    ChangedCells?: DatasheetCellRef[] | undefined;
}

export interface SortItem {
    /** Gets or sets database-Field to be sorted. */
    Field?: string | undefined;
    /** Gets or sets the sorting direction ("asc" or "desc") */
    Dir?: string | undefined;
}

/** Parameter for setting the user startpage. */
export interface StartPageRequestParameter extends PageTokenParameter {
    /** Gets or sets new start page for the user. */
    StartPage?: string | undefined;
}

/** Definition of a form tab. */
export interface TabDefinition {
    /** Gets or sets header textblock name. */
    TabHeader: string;
    /** Gets or sets name of the tab. */
    TabName: string;
    /** Gets or sets form columns in this tab. */
    Columns?: FormColumnDefinition[][] | undefined;
    /** Gets or sets the individual widths for each column if available. */
    ColumnWidths?: string[] | undefined;
    /** Gets form groups in this tab. */
    readonly Groups?: GroupDefinition[] | undefined;
}

/** ClientDefinition for Tree. */
export interface TreeDefinition extends BaseGridDefinition {
    /** Gets or sets list of TreeLinkDefinitions */
    TreeLinkDefinitions?: TreeLinkDefinition[] | undefined;
    /** Gets or sets name of the column which contains the nodeText. */
    NodeTextColumnName?: string | undefined;
    /** Gets or sets name of the column which contains the boolean value if the node has childnodes. */
    HasChildNodesColumnName?: string | undefined;
    /** Gets or sets cssClass for the Tree. */
    TreeCssClass?: string | undefined;
    /** Gets or sets name of the column which contains the boolean value if the node should be expanded on load. */
    ExpandedColumnName?: string | undefined;
    /** Gets or sets a value indicating whether true if the ContextMenuItems should be removed if they are disabled. */
    RemoveDisabledContextMenuItems?: boolean;
    /** Gets or sets text shown while loading nodes. */
    NodesLoadingCaption?: string | undefined;
}

/** Definition for treelinks for the client. */
export interface TreeLinkDefinition {
    /** Gets or sets iD of TreeLink */
    TreeLinkID?: number | undefined;
    /** Gets or sets rangeColumnName */
    RangeColumnName?: string | undefined;
    /** Gets or sets value for Range From */
    RangeFrom?: number | undefined;
    /** Gets or sets value for Range To */
    RangeTo?: number | undefined;
    /** Gets or sets caption */
    Caption?: string | undefined;
    /** Gets or sets icon path */
    Icon?: string | undefined;
    /** Gets or sets represents css class */
    CssClass?: string | undefined;
    /** Gets or sets type Id */
    TypeID?: number;
    /** Gets or sets link Path */
    Link?: string | undefined;
    /** Gets or sets linkMode describes how Link should be opened (Window f.e) */
    LinkMode?: string | undefined;
    /** Gets or sets contains script which should be triggered when TreeLink is clicked */
    Script?: string | undefined;
    /** Gets or sets a value indicating whether true if isDefault is set */
    IsDefault?: boolean;
    /** Gets or sets a value indicating whether is Entry for Drag and Drop */
    IsDragDropCommand?: boolean;
    /** Gets or sets text for Comfirmation */
    ConfirmText?: string | undefined;
    /** Gets or sets name of Command */
    CommandName?: string | undefined;
    /** Gets or sets a value indicating whether true if Command is set */
    IsCommand?: boolean;
}

/** Custom user configuration. */
export interface UserGridConfigDefinition {
    /** Gets or sets the ID of the configuration. */
    UserGridConfigID?: number;
    /** Gets or sets the ID of the grid. */
    GridID?: number;
    /** Gets or sets the configuration as JSON. */
    Configuration?: string | undefined;
}

/** Request to save user grid config. */
export interface UserGridConfigRequest {
    /** Gets or sets the JSON confiugration. */
    Configuration?: string | undefined;
    /** Gets or sets the id of the Grid. */
    GridID?: number;
    /** Gets or sets the existing ID of the UserGridConfiguration. */
    UserGridConfigID?: number | undefined;
}

/** RequestContextParameter for setting UserGridConfiguration */
export interface UserMappingConfigContextParameter extends ContextParameter {
    /** Gets or sets the id of the mapping config. */
    UserMappingConfigID?: number | undefined;
    /** Gets or sets the name of the mapping. */
    MappingName?: string | undefined;
    /** Gets or sets a value indicating whether gets or sets the indicator wether this configuration is system wide. */
    IsSystem?: boolean;
    /** Gets or sets the name of the configuration. */
    Name?: string | undefined;
    /** Gets or sets the list of user grid configs. */
    UserGridConfig?: UserGridConfigRequest[] | undefined;
}

/** Custom user configuration. */
export interface UserMappingConfigDefinition {
    /** Gets or sets the ID of the configuration. */
    UserMappingConfigID?: number;
    /** Gets or sets the name of the configuration. */
    Name?: string | undefined;
    /** Gets or sets a value indicating whether gets or sets the value indicating wether the config is a system config. */
    IsSystem?: boolean;
    /** Gets or sets a value indicating whether gets or sets wether the config is the initial selected config. */
    IsInitial?: boolean;
    /** Gets or sets the user grid configs for this mapping definition. */
    UserGridConfig?: UserGridConfigDefinition[] | undefined;
}

/** Result class for UserMappingConfig requests. */
export interface UserMappingConfigResult extends BaseResult {
    /** Gets or sets the id of the UserGridConfig. */
    UserMappingConfigID?: number;
}

export interface UserPickerItem extends BaseResult {
    UserID?: number;
    UserNameLong?: string | undefined;
    UserName?: string | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    /** Gets or sets the email address of the user. */
    Email?: string | undefined;
    Picture?: string | undefined;
    Phone?: string | undefined;
    Title?: string | undefined;
}

export interface VersionInfo extends BaseResult {
    Assemblies?: VersionItem[] | undefined;
    DmsVersions?: VersionItem[] | undefined;
    DmsIntVersions?: VersionItem[] | undefined;
    AppVersions?: VersionItem[] | undefined;
    LastConfigChange?: Date | undefined;
}

export interface VersionItem {
    Name?: string | undefined;
    Version?: string | undefined;
    Date?: Date | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}